/** 列表和甘特图共用月/周历的工期口径，只整理已鉴权数据，不生成或修改安排。
 * 跨天任务只列一次；周日休息、午夜结束边界仍交给原日历算法，避免三种视图互相矛盾。
 */
import { scheduleLanes } from './scheduleLanes';
import { lastWorkDay } from './scheduleCalendar';

/** dates 为当前选定期间；保留原始日期用于显示，用期间内首个施工日打开详情，避免点击跨月任务后突然跳月。 */
export function scheduleViewRows(dates, tasks, events) {
  const rows = new Map();
  scheduleLanes(dates, tasks, events).segments.forEach(segment => {
    const { item, kind } = segment, key = `${kind}:${item.id}`;
    if (!rows.has(key)) rows.set(key, { key, kind, item, segments: [],
      start: kind === 'task' ? item.startAt.slice(0, 10) : item.date,
      end: kind === 'task' ? lastWorkDay(item) : item.date,
      visibleDate: dates[segment.start] });
    rows.get(key).segments.push(segment);
  });
  return [...rows.values()].sort((a, b) => a.start.localeCompare(b.start) || a.key.localeCompare(b.key));
}
